import Cookies from 'js-cookie'

export const PROMO_COOKIE_KEY = 'promo_code'

const isBrowser = typeof document !== 'undefined'

/**
 * Session cookie mirroring the promo store's explicit promo code so the
 * back-end can render discounted prices server-side. Declared as an
 * essential cookie in Cookiebot.
 */
const promoCookie = {
  get: () => (isBrowser ? Cookies.get(PROMO_COOKIE_KEY) : undefined),
  set: (code) => {
    if (isBrowser) {
      Cookies.set(PROMO_COOKIE_KEY, code, { path: '/', sameSite: 'Lax', secure: window.location.protocol === 'https:' })
    }
  },
  clear: () => {
    if (isBrowser) Cookies.remove(PROMO_COOKIE_KEY, { path: '/' })
  },
}

export default promoCookie
